export const NAV_BAR_MENU_PAGES = [
  { name: "Projects", path: "/projects/" },
  { name: "Services", path: "/services/" },
  { name: "Team", path: "/team/" },
  {
    name: "Contact us",
    path: "#",
    onClick: (e: React.MouseEvent<HTMLAnchorElement, MouseEvent>) => {
      e.preventDefault();
      document
        .getElementById("contact-us-footer")
        ?.scrollIntoView({ behavior: "smooth" });
    },
  },
];

export const ALLOW_STRICTLY_NECESSARY_KEY = "allowStrictlyNecessary";

export const ALLOW_ANALYTICS_KEY = "allowAnalytics";
